import { StateCreator } from "zustand";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import { RemoteFetchZoneMaster } from "../../../data/usecases/remote-fetch-zone";
import Endpoints from "../../../domain/endpoints";
import { TerritoryData } from "../../../domain/models/territory-data";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";


export interface FetchZoneMasterInterface {
  zoneMasterData: TerritoryData[];
  fetchZoneMaster: Function;
  clearZoneMaster: Function;
}

const initialStates = {
  zoneMasterData: [],
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchZoneMasterSlice: StateCreator<FetchZoneMasterInterface> = (
  set
) => ({
  ...initialStates,
  fetchZoneMaster: async () => {
     const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
     const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteFetchMasters = new RemoteFetchZoneMaster(
      `${BASE_URL}${Endpoints.FETCH_ZONE_MASTER}`,
      axiosHttpClient
    );
    set(() => ({ zoneMasterData: [] }));
    let result = await remoteFetchMasters.fetch();
    if (result) {
      set(() => ({ zoneMasterData: result.zones }));
    }
  },
  clearZoneMaster: () => {
    set(() => ({ zoneMasterData: [] }));
  },
});
